<div mat-dialog-title class="title d-flex justify-content-between">
    <div>Berichtinformatie</div>
    <button class="close" mat-dialog-close="" mat-icon-button tabindex="-1">
        <mat-icon class="fas fa-close"></mat-icon>
    </button>
</div>
<div mat-dialog-content class="dialog-content">
    <div class="d-flex flex-column h-100">
        <mat-list class="flex-fill overflow-auto">
            <div class="pb-0" mat-subheader>Bericht</div>
            <mat-list-item class="message-line">
                <div [innerHTML]="data.message.message" class="message" mat-line></div>
                <small class="text-end" mat-line>
                    @if (Utils.isToday(data.message.updated_at)) {
                        Vandaag {{ data.message.updated_at | date: 'H:mm' }}
                    } @else {
                        <span class="d-none d-sm-block">
                            {{ data.message.updated_at | date: 'd MMM yyyy H:mm' }}
                        </span>
                        <span class="d-block d-sm-none">
                            {{ data.message.updated_at | date: 'd MMM H:mm' }}
                        </span>
                    }
                </small>
            </mat-list-item>
            <div class="pb-0" mat-subheader>Gelezen door</div>
            @for (
                chatUser of data.chat.chat_users | whereGreaterOrEqual: 'last_read' : data.message.id;
                track chatUser
            ) {
                <mat-list-item>
                    <div mat-line>
                        {{ chatUser.user.name }}
                    </div>
                </mat-list-item>
            }
            @if ((data.chat.chat_users | whereLess: 'last_read' : data.message.id)?.length) {
                <div class="mt-3 pb-0" mat-subheader>Verzonden aan</div>
            }
            @for (chatUser of data.chat.chat_users | whereLess: 'last_read' : data.message.id; track chatUser) {
                <mat-list-item>
                    <div mat-line>
                        {{ chatUser.user.name }}
                    </div>
                </mat-list-item>
            }
        </mat-list>
    </div>
</div>
